import axios from "axios";
import {
    config,
    useKeycloak,
    sessionAccessToken,
    sessionActiveTime,
    sessionRefreshToken,
    sessionIdToken,
    sessionUser,
    sessionUsername,
    sessionUserPerms,
} from "../config";
import {
    getUserByUsername,
    getUserInfoViaToken,
    getUserPermissionsByUsername,
} from "../services/userService";
import {BASE_URL, HIEBUS_CONFIG} from "./authConfig";
import {logActivity} from "../services/utilService";

function rand() {
    return (Date.now() + "" + Math.random()).replace(".", "");
}

function redirect404() {
    window.location = BASE_URL + "unauthorized";
}

export default class AuthService {
    signinRedirect = () => {
        let state = rand();
        let nonce = rand();
        localStorage.setItem(HIEBUS_CONFIG.client_id + "_state", state);
        window.location = HIEBUS_CONFIG.authorizationUrl +
            "?" +
            "client_id=" +
            encodeURI(HIEBUS_CONFIG.client_id) +
            "&redirect_uri=" +
            encodeURI(HIEBUS_CONFIG.redirect_uri) +
            "&response_type=" +
            encodeURI(HIEBUS_CONFIG.response_type) +
            "&scope=" +
            encodeURI(HIEBUS_CONFIG.scope) +
            "&state=" +
            encodeURI(state) +
            "&nonce=" +
            encodeURI(nonce);
    };

    isAuthenticated = () => {
        const token = sessionStorage.getItem(sessionAccessToken);
        return !!token;
    };

    logoutClient = () => {
        if ((process.env.REACT_APP_CLIENT_AUTH).includes('level2'))
            window.location = HIEBUS_CONFIG.logout_uri + '?id_token_hint=' + sessionStorage.getItem(sessionIdToken)
        else
            window.location = BASE_URL
        sessionStorage.clear();
        localStorage.clear();
    };

    navigateToScreen = () => {
        window.location.replace(BASE_URL);
    };

    signinRedirectCallback = async () => {
        // validate token
        let result = new URLSearchParams(window.location.search);
        if (
            result.has("code") &&
            result.has("state") &&
            result.get("state") === localStorage[HIEBUS_CONFIG.client_id + "_state"]
        ) {
            localStorage.removeItem(HIEBUS_CONFIG.client_id + "_state");

            //request tokens
            let params = new URLSearchParams();
            params.append("client_id", HIEBUS_CONFIG.client_id);
            params.append("client_secret", HIEBUS_CONFIG.client_secret);
            params.append("redirect_uri", HIEBUS_CONFIG.redirect_uri);
            params.append("grant_type", "authorization_code");
            params.append("code", result.get("code"));

            axios
                .post(HIEBUS_CONFIG.token_endpoint, params)
                .then(async (response) => {
                    sessionStorage.clear();
                    sessionStorage.setItem(sessionAccessToken, response.data.access_token);
                    response.data.refresh_token && sessionStorage.setItem(sessionRefreshToken, response.data.refresh_token);
                    response.data.id_token && (sessionStorage.setItem(sessionIdToken, response.data.id_token));
                    sessionStorage.setItem(sessionActiveTime, Date.now());

                    const { data: userInfo } = await getUserInfoViaToken();
                    sessionStorage.setItem(sessionUsername, userInfo.preferred_username);
                    let {data: user} = await getUserByUsername(userInfo.preferred_username);
                    if (user.length === 0) {
                        sessionStorage.removeItem(sessionAccessToken);
                        sessionStorage.removeItem(sessionRefreshToken);
                        sessionStorage.removeItem(sessionActiveTime);
                        sessionStorage.removeItem(sessionUsername);
                        redirect404();
                    }
                    sessionStorage.setItem(sessionUser, JSON.stringify(user[0]));

                    const {data: userPermissions} = await getUserPermissionsByUsername(userInfo.preferred_username);
                    sessionStorage.setItem(sessionUserPerms, JSON.stringify(userPermissions));
                    await logActivity("/login", "LOGIN_SUCCESS");
                    userPermissions && (window.location = BASE_URL);
                }).catch((reason) => {
                    console.log('Authentication failed: ', reason)
                })
        } else {
            redirect404();
        }
    };
}
